import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { resolveVaultApiUrl } from './env-profiles';

/**
 * Registra `LOGOUT` en Vault (`POST /api/auth/logout`) antes de limpiar la sesión.
 * Usa `fetch` + `keepalive` para que la petición no se cancele al redirigir al login
 * (misma sesión Simappe que `GET /api/auth/me` para LOGIN; dev@ en DEV, qa@ en QA).
 */
@Injectable({ providedIn: 'root' })
export class VaultAuthLogoutService {
  recordLogout$(accessToken?: string | null): Observable<void> {
    const token = (accessToken ?? readAccessToken()).trim();
    if (!token || typeof window === 'undefined') {
      return of(void 0);
    }

    const base = resolveVaultApiUrl().replace(/\/$/, '');
    const url = base ? `${base}/api/auth/logout` : '/api/auth/logout';

    return new Observable<void>((subscriber) => {
      fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: '{}',
        keepalive: true,
      })
        .then(() => {
          subscriber.next();
          subscriber.complete();
        })
        .catch(() => {
          subscriber.next();
          subscriber.complete();
        });
    });
  }
}

function readAccessToken(): string {
  if (typeof localStorage === 'undefined') return '';
  return localStorage.getItem('access_token') ?? '';
}
